import { PDFDocument, PDFForm, PDFTextField } from 'pdf-lib';
import { downloadFiles } from '../../utilities';
import { FIREBASE_STORAGE_URL } from '../../app-settings';
import { getOfficialDeckListRows } from './functions';
import { DeckState } from '../../models/Deck';
import { UserSettings } from '../../models/UserSettings';

export async function downloadOfficialPdf(props: {
    deckState: DeckState,
    userSettings: UserSettings
}) {
    const existingPdfBytes = await fetch(`${FIREBASE_STORAGE_URL}/official-deck-list.pdf`).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const form = pdfDoc.getForm();

    const officialDeckListRows = getOfficialDeckListRows({
        deckState: props.deckState,
        userSettings: props.userSettings
    });

    let currentCard = 1;
    for (const row of officialDeckListRows.deck) {
        const currentCardString = currentCard.toString().padStart(2, "0");

        const cardNumberFieldKey = `CARDno-${currentCardString}`;
        const rarityFieldKey = `RARITY-${currentCardString}`;
        const backupRarityFieldKey = `RARITY${currentCardString}`;
        const nameFieldKey = `NAME-${currentCardString}`;

        const cardNumberField = getTextField({ form: form, keys: [cardNumberFieldKey] });
        const rarityField = getTextField({ form: form, keys: [rarityFieldKey, backupRarityFieldKey] });
        const nameField = getTextField({ form: form, keys: [nameFieldKey] });

        cardNumberField.setText(row.number);
        rarityField.setText(row.rarity);
        nameField.setText(row.name);
        currentCard++;
    }

    let currentLB = 1;
    for (const row of officialDeckListRows.lb) {
        const cardNumberFieldKey = `CARDno-LB${currentLB}`;
        const rarityFieldKey = `RARITY-LB${currentLB}`;
        const backupRarityFieldKey = `RARITY${currentLB}`;
        const nameFieldKey = `NAME-LB${currentLB}`;

        const cardNumberField = getTextField({ form: form, keys: [cardNumberFieldKey] });
        const rarityField = getTextField({ form: form, keys: [rarityFieldKey, backupRarityFieldKey] });
        const nameField = getTextField({ form: form, keys: [nameFieldKey] });

        cardNumberField.setText(row.number);
        rarityField.setText(row.rarity);
        nameField.setText(row.name);
        currentLB++;
    }

    const pdfBytes = await pdfDoc.save();
    downloadFiles(pdfBytes, props.deckState.editableFields.unsaved.name ?? "materiahunter-official-deck-list", "application/pdf");
}

function getTextField(props: {
    form: PDFForm,
    keys: string[]
}): PDFTextField {
    let field: PDFTextField | null = null;
    for (let i = 0; i < props.keys.length; i++) {
        try {
            const key = props.keys[i];
            field = props.form.getTextField(key);
        } catch {

        }
    }

    if (!field) {
        throw Error(`KEY DOES NOT EXIST ${JSON.stringify(props.keys)}`);
    }

    return field;
}